/* ============================================================================
   type / ค่าคงที่ ที่หน้า Walk & Run กับการ์ดจับคู่ชื่อใช้ร่วมกัน
   API: backend/src/routes/adminWalkrun.js · ตาราง: sql/mssql/007 + 009
   ============================================================================ */

export const BASE = '/api/admin/walkrun'

export const nf = new Intl.NumberFormat('th-TH')

export function errorText(err: unknown): string {
  return err instanceof Error ? err.message : String(err)
}

/** ผลลัพธ์ที่แบ่งหน้า — total คือทั้งหมด ไม่ใช่จำนวนในหน้านี้ (backend/src/lib/paging.js) */
export type Paged<T> = { total: number; page: number; pageSize: number } & T

/** ชื่อในแอปที่ยังไม่ได้จับคู่กับพนักงาน */
export type Unmapped = {
  nameKey: string
  name: string
  steps: number
  dayCount: number
  lastDay: string | null
}

/**
 * พนักงานหนึ่งคนกับชื่อทั้งหมดที่เขาใช้ในแอป
 *
 * ⚠️ `names[i]` คู่กับ `nameKeys[i]` เสมอ — backend เรียงทั้งสองชุดด้วย ORDER BY
 *    เดียวกัน (ORDER BY a.name) การถอดคู่ใช้ nameKeys[i] จึงตรงกับชื่อที่แสดง
 */
export type Alias = {
  empCode: string
  empName: string | null
  department: string | null
  /** > 1 = คนนี้เปลี่ยนชื่อระหว่างโครงการ */
  nameCount: number
  steps: number
  names: string[]
  nameKeys: string[]
}

export type Employee = {
  empCode: string
  empName: string
  department: string | null
  position: string | null
  /**
   * จับคู่กับชื่อในแอปไปแล้วกี่ชื่อ
   *
   * ⚠️ > 0 **ไม่ได้แปลว่าเลือกไม่ได้** — 1 พนักงานมีได้หลายชื่อโดยตั้งใจ (คนเปลี่ยนชื่อ
   *    ในแอปกี่รอบก็จับคู่เพิ่ม) ใช้แค่แยกกลุ่มใน dropdown ให้คนที่ยังไม่จับคู่ขึ้นก่อน
   */
  aliasCount: number
}

/**
 * ชื่อที่ "หายไป" จากไฟล์ล่าสุด — ตัวชี้ว่าใครน่าจะเปลี่ยนชื่อ
 *
 * ต่างจากรายการ "ยังไม่จับคู่" ตรงที่รายการนั้นปนกันทั้งคนเข้าใหม่จริงและคนเก่า
 * ที่เปลี่ยนชื่อ ส่วนตัวนี้บอกเจาะจงว่าควรไปจับคู่กับ **พนักงานคนเดิม**
 */
export type RenameHints = {
  importId: number | null
  fileName: string | null
  missing: { nameKey: string; name: string; steps: number; lastDay: string | null }[]
  fresh: { nameKey: string; name: string; steps: number }[]
  /**
   * ชื่อที่ต่างกันจริงแต่ DB รวมให้เป็นคนเดียวแล้ว — collation Thai_CI_AI มองอิโมจิ
   * เป็นอักขระน้ำหนักศูนย์ ทำให้ N'🔥ชื่อ' = N'ชื่อ' ในสายตา SQL
   * ไม่ต้องทำอะไร ตัวเลขถูกแล้ว (ดูคำเตือนที่ backend/src/lib/walkrun.js → nameKeyOf)
   */
  twins: { name: string; keys: number }[]
}
